
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { makeFormModel, makeFormValidation } from 'ah-common-lib/src/form/helpers';
import { emailField, passwordField } from 'ah-common-lib/src/form/models';
import { required } from '@vuelidate/validators';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import useVuelidate, { Validation } from '@vuelidate/core';
import { sameAsField } from 'ah-common-lib/src/form/validators';

const resetPasswordFormModel = () =>
  makeFormModel({
    name: 'resetPasswordForm',
    title: 'Reset Password',
    fieldType: 'form',
    fields: [
      emailField('email', 'Email', { autocomplete: 'username', hidden: true, required: false }),
      passwordField('password', 'Password', true, { allowShowPassword: true }),
      passwordField(
        'passwordConfirm',
        'Confirm new password',
        false,
        {
          autocomplete: 'new-password',
        },
        {
          required,
          passwordMatch: sameAsField('password'),
        }
      ),
    ],
  });

@Component({
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations: {
    resetPasswordForm: makeFormValidation(resetPasswordFormModel()),
  },
})
export default class ResetPasswordView extends Mixins(WithRequestManager) {
  resetPasswordForm = resetPasswordFormModel();

  @Prop({ required: true }) token!: string;

  private v$!: Validation;

  private email = '';

  beforeMount() {
    this.requestManager
      .sameOrCancelAndNew(
        'getEmailForPasswordResetToken',
        this.$services.account.getEmailForPasswordResetToken(this.token),
        this.token
      )
      .subscribe(
        (response) => {
          this.email = response.email;
          this.resetPasswordForm.email = this.email;
        },
        () => {
          this.$toast.error('Error with token provided.');
          this.$router.replace('/');
        }
      );
  }

  submit() {
    const payload = {
      email: this.email,
      token: this.token,
      newPassword: this.resetPasswordForm.password,
    };

    this.requestManager
      .sameOrCancelAndNew('confirmResetPassword', this.$services.account.confirmResetPassword(payload), payload)
      .subscribe(() => {
        this.$toast.success('Password reset succesful.');
        this.$router.push('/login');
      });
  }

  get loading() {
    return this.requestManager.requestStates.confirmResetPassword === 'pending';
  }
}
